import { ReactNode } from "react";
import "../stylesheets/label.scss";

// PROPS


type LabelProps = {
    title: string,
    subtitle?: string,
    icon?: ReactNode,
    onClick?: () => void;
}

// COMPONENT

function Label({title, subtitle, icon, onClick} : LabelProps) {
    return (
        <label onClick={onClick}>
            {icon}
            <div>
                <span className="primary-text">{title}</span>
                <span className="secondary-text">{subtitle}</span>
            </div>
        </label>
    )

}

export default Label;